"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _SuccessCircle = _interopRequireDefault(require("../../icons/statuses/SuccessCircle"));

var _Delete = _interopRequireDefault(require("../../icons/actions/Delete"));

var _styles = _interopRequireDefault(require("./styles"));

var _styles2 = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Notification =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification(props) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Notification).call(this, props));
    _this.state = {
      open: props.open,
      transitionedIn: props.open
    };
    _this.openNotification = _this.openNotification.bind(_assertThisInitialized(_this));
    _this.closeNotification = _this.closeNotification.bind(_assertThisInitialized(_this));
    _this.startAutoHideTimer = _this.startAutoHideTimer.bind(_assertThisInitialized(_this));
    _this.clearTimeouts = _this.clearTimeouts.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var open = this.props.open;
      if (open) this.startAutoHideTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;

      if (open !== prevProps.open) {
        this.clearTimeouts();
        if (open) this.openNotification();else this.closeNotification();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeouts();
    }
  }, {
    key: "openNotification",
    value: function openNotification() {
      var _this2 = this;

      this.setState({
        open: true
      }, function () {
        _this2.transitionTimeout = setTimeout(function () {
          _this2.setState({
            transitionedIn: true
          }, function () {
            var _this2$props = _this2.props,
                autoHideDuration = _this2$props.autoHideDuration,
                onRequestClose = _this2$props.onRequestClose;

            if (autoHideDuration) {
              _this2.autoHideTimeout = setTimeout(onRequestClose, autoHideDuration);
            }
          });
        }, 0);
      });
    }
  }, {
    key: "closeNotification",
    value: function closeNotification() {
      var _this3 = this;

      this.clearTimeouts();
      this.setState({
        transitionedIn: false
      }, function () {
        _this3.transitionTimeout = setTimeout(function () {
          _this3.setState({
            open: false
          });
        }, 300);
      });
    }
  }, {
    key: "startAutoHideTimer",
    value: function startAutoHideTimer() {
      var _this$props = this.props,
          autoHideDuration = _this$props.autoHideDuration,
          onRequestClose = _this$props.onRequestClose;
      if (autoHideDuration) this.autoHideTimeout = setTimeout(onRequestClose, autoHideDuration);
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      clearTimeout(this.autoHideTimeout);
      clearTimeout(this.transitionTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          openState = _this$state.open,
          transitionedIn = _this$state.transitionedIn;

      var _this$props2 = this.props,
          autoHideDuration = _this$props2.autoHideDuration,
          children = _this$props2.children,
          classes = _this$props2.classes,
          horizontalAlignment = _this$props2.horizontalAlignment,
          icon = _this$props2.icon,
          onRequestClose = _this$props2.onRequestClose,
          verticalAlignment = _this$props2.verticalAlignment,
          props = _objectWithoutProperties(_this$props2, ["autoHideDuration", "children", "classes", "horizontalAlignment", "icon", "onRequestClose", "verticalAlignment"]);

      if (!openState) return null;
      return _react["default"].createElement("div", _extends({
        className: (0, _classnames["default"])(classes.root, !transitionedIn ? classes.hidden : null)
      }, props), icon, _react["default"].createElement("div", {
        className: classes.content
      }, children), _react["default"].createElement(_Delete["default"], {
        className: classes.closeIcon,
        onClick: onRequestClose
      }));
    }
  }]);

  return Notification;
}(_react["default"].Component);

Notification.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Bool flag to open/close the notification */
  open: _propTypes["default"].bool,

  /** Children of Notification component */
  children: _propTypes["default"].node,

  /** Icon to show in the notification */
  icon: _propTypes["default"].node,

  /** Time in ms to close the Notification after the time specified */
  autoHideDuration: _propTypes["default"].number,

  /** Notification can be aligned vertically at the 'start', 'center' or 'end' */
  verticalAlignment: _propTypes["default"].oneOf(['start', 'center', 'end']),

  /** Notification can be aligned horizontally at the 'start', 'center' or 'end' */
  horizontalAlignment: _propTypes["default"].oneOf(['start', 'center', 'end']),

  /** Callback called when notification is closed */
  onRequestClose: _propTypes["default"].func
};
Notification.defaultProps = {
  open: false,
  children: null,
  icon: _react["default"].createElement(_SuccessCircle["default"], {
    color: _styles2.colors.green
  }),
  autoHideDuration: 5000,
  verticalAlignment: 'end',
  horizontalAlignment: 'end',
  onRequestClose: function onRequestClose() {}
};

var _default = (0, _withStyles["default"])(_styles["default"])(Notification);

exports["default"] = _default;